var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"customer-imports-container"}},[_c('importer',{attrs:{"fields":_vm.importProperties,"field-names":_vm.translatedProperties,"callback":_vm.callback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }